export const DO_GET_PURCHASED_PRODUCT = "DO_GET_PURCHASED_PRODUCT";
export const DO_GET_PURCHASED_PRODUCT_SUCCESS =
  "DO_GET_PURCHASED_PRODUCT_SUCCESS";
